"use client";
import { useEffect, useRef } from "react";
import { type Spec, SwaggerUIBundle } from "swagger-ui-dist";

export default function SwaggerPageContent({ spec }: { spec: Spec }) {
	const swaggerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		SwaggerUIBundle({ domNode: swaggerRef.current, spec });
	}, [spec]);

	return <div className="swagger-ui-wrapper" ref={swaggerRef} />;
}
